import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IFooterPage } from '@newroom-connect/library/interfaces';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'nrc-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  public readonly currentProjectSlug = input<string | null>(null);
  public readonly pages = input<IFooterPage[] | null>(null);
  public readonly appVersion = input('');
  public readonly isProdEnvironment = input(false);
  public readonly imprintLabel = input('Imprint');
  public readonly privacyLabel = input('Privacy');

  public readonly showImprint = computed(() => {
    const pages = this.pages();

    return pages === null || !pages.some((link) => link.slug === 'imprint');
  });

  public readonly showPrivacy = computed(() => {
    const pages = this.pages();

    return pages === null || !pages.some((link) => link.slug === 'privacy');
  });

  /**
   * Build a routerLink array for the given slug.
   *
   * @param slug The footer link slug (e.g. 'imprint').
   * @returns The routerLink segments array.
   */
  public buildRouterLink(slug: string): (string | null)[] {
    return ['/', this.currentProjectSlug(), 'legal', slug];
  }
}
